import { GridApi } from "ag-grid-community";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { AddRuleIcon } from "../../icon";
import * as selector from '../../selectors/selectors';
import {
	buttonLabels,
	pageTitles
} from "../shared/constants";
import AddRuleComponent from "./add-rule.component-channels";
import PageHeaderComponent from "../shared/page-header.component";
import PrivateRulesComponent from "./private-rules-component";
import { useLocation } from "react-router-dom";
import { ChannelType } from "../../models/conversations";
import { ChannelAutomatedReply } from "../../models/automations.model";
import { ChannelAccountModel, ChannelAccountStatus } from "../../models/channels/channels.model";


interface Props {

}

const RulesComponent = () => {
	const location = useLocation()
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const Channels: ChannelAccountModel[] = useSelector(selector.Channels)

	const [SearchInput, SetSearchInput] = useState<string>("");
	const [editoption, SetEditoption] = useState(false);
	const [OperatingRule, SetOperatingRule] = useState<ChannelAutomatedReply>();
	const [OperatingRowId, SetOperatingRowId] = useState<string>("");
	const [editOption, SetEditOption] = useState(false);
	const [gridApi, setGridApi] = useState<GridApi>(null);
	const [columnApi, setColumnApi] = useState<any>(null);
	const [channel, setChannel] = useState<ChannelType>(ChannelType.FACEBOOK)
	const [page, setPage] = useState<any>(null)
	const [automationCount, setAutomationCount] = useState<number>(0)
	const [gridRefresh, setGridRefresh] = useState<boolean>(false)

	const openAddRule = (rowId: string, obj?: ChannelAutomatedReply) => {
		SetEditoption(true);
		SetOperatingRule(obj);
		SetOperatingRowId(rowId);
	};

	const closeAddRule = () => {
		SetEditoption(false);
		SetOperatingRule(undefined);
		SetOperatingRowId("");
	};

	const editOptionHandler = (value) => {
		SetEditOption(value);
	};

	const onGridReady = (params) => {
		setGridApi(params.api)
		setColumnApi(params.columnApi)
	}

	const getGridTitle = () => {
		return automationCount === 1 ? "1 Automation Rule" : automationCount + "  " + pageTitles.AUTOMATION_RULES;
	}

	useEffect(() => {
		if (SearchInput !== "") {
			gridApi.setQuickFilter(SearchInput);
		}

	}, [gridApi, columnApi])

	useEffect(() => {
		refreshData();
	}, [location.pathname])

	const globalSearch = (event: any) => {
		SetSearchInput(event.target.value);
		gridApi.setQuickFilter(event.target.value);
	};

	const refreshData = (e?: any) => {
		if (!!e) {
			setGridRefresh(true)
		}
		else {
			setGridRefresh(false)
		}
		if (!!columnApi) {
			columnApi.resetColumnState();
		}
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	};

	const runLoader = () => {
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	}

	useEffect(() => {
		SetSearchInput("")
	}, [location.pathname])

	const handleChannel = (value: number) => {
		setChannel(value)
	}

	const handlePage = (value: string) => {
		setPage(value)
	}

	const handleAutomationCount = (value: number) => {
		setAutomationCount(value)
	}

	return IsMobileDevice && editoption ? (
		<AddRuleComponent
			OnClose={closeAddRule}
			Show={editoption}
			Rule={OperatingRule}
			ButtonLabel={buttonLabels.SAVE}
			HandleSubmitSuccess={(e) => refreshData(e)}
		/>
	) : (
		<div className="d-flex flex-direction h-p-100 o-hidden justify-between">
			<div className='w-p-96 mx-auto'>
				<PageHeaderComponent
					Actions={[
						{
							OnClick: () => openAddRule("", undefined),
							ButtonLabel: buttonLabels.ADD_RULE,
							Icon: AddRuleIcon,
							Variant: Channels.find(x=>x.ID === page)?.Status === ChannelAccountStatus.CONNECTED ? "primary-btn" : "disabled-btn",
						},
					]}
					ShowFilterIcon={false}
					onSearch={globalSearch}
					GridTitle={getGridTitle()}
					PlaceHolder={"Find a Rule..."}
				/>
			</div>
			<PrivateRulesComponent
				SearchInput={SearchInput}
				refreshData={refreshData}
				editOption={editOption}
				editOptionHandler={editOptionHandler}
				onGridReady={onGridReady}
				runLoader={runLoader}
				gridApi={gridApi}
				handleChannel={handleChannel}
				handlePage={handlePage}
				count={handleAutomationCount}
				GridRefresh={gridRefresh}
			/>

			{editoption && (
				<AddRuleComponent
					OnClose={closeAddRule}
					Show={editoption}
					Rule={OperatingRule}
					ButtonLabel={buttonLabels.SAVE}
					HandleSubmitSuccess={(e) => refreshData(e)}
					Channel={channel}
					Page={page}
				/>
			)}
		</div>
	);
}




export default RulesComponent;
